import React, { useState, useEffect } from "react";
import { BASE_PADDING } from "constants/Layout";
import TicketsCreationAPI from "restAPI/TicketsCreationAPI";
import { Row, Col, Alert } from "antd";


const TicketInProgressWarning = ({findings, ...props}) => {
    const [findingsWithTicketInProgress, setFindingsWithTicketInProgress] = useState([])

    const getTicketStatus = (finding) => {
        const { promise, cancel } =  TicketsCreationAPI.getJiraTicketDetails(finding.id)
        promise.then((data) => {
        if(data[0]?.status ===  "TO_BE_CREATED"){
            setFindingsWithTicketInProgress(arr => [...arr, finding.id])
          }
        })
        return cancel;
    }

    useEffect(() => {
        // Skipping API calls if more than 9 findings
        if(findings.length >= 10){
            return;
        }
        let cancelArray=[];
        findings.forEach((finding) => {
        if(!finding.armorcodeTicket) {
            cancelArray.push(getTicketStatus(finding))
          }})
        return () => {
            cancelArray.forEach((cancel) => cancel())
        }
    }, [findings])
    
    let message = "";
    if(findings.length >= 10){
        message = "Finding whose ticket creation is in progress, new tickets will not be created."; 
    } else if(findingsWithTicketInProgress.length > 0){
        message = `Finding(s) ${findingsWithTicketInProgress.join(', ')} already have ticket creation in progress and new tickets will not be created for these findings.`;
    }

    return  message.length > 0 ?   
    <Row gutter={[BASE_PADDING, BASE_PADDING]}>
        <Col span={24}>
            <Alert type="warning" showIcon message={message}/>
        </Col>
    </Row> : null;
        
}

export default TicketInProgressWarning;